import { Directive, computed, input } from '@angular/core';
import { shared } from '@tig-dpqa-cloud/contract-backend-common';
import {
  getDisplayClassWithCssClass,
} from '../../util/get-display-class-for-slide-scan-status';

@Directive({
  selector: '[dpqaStatusIndicator]',
  standalone: true,
  host: {
    '[class.no-issues]': 'statusClass() === "no-issues"',
    '[class.has-issues]': 'statusClass() === "has-issues"',
    '[class.needs-review]': 'statusClass() === "needs-review"',
    '[class.qc-interrupted]': 'statusClass() === "qc-interrupted"',
  },
})
export class StatusIndicatorDirective {
  generalQcStatus = input.required<shared.SlideScanGeneralQcStatusType>();
  aggregatedStatus = input<shared.AggregatedStatusType | undefined>(undefined);
  detectedIssues = input<shared.SlideScanDetectedIssue[]>([]);
  aiProcessingStatus = input.required<'SUCCESS' | 'FAILED'>();
  isEditing = input<boolean>(false);

  private aiQcInterrupted = computed(
    () => this.aiProcessingStatus() !== 'SUCCESS' &&
      this.generalQcStatus() === shared.SlideScanGeneralQcStatus.enum.NOT_SET,
  );

  statusClass = computed(() => {
    const { cssClass } = getDisplayClassWithCssClass({
      aiFailed: this.aiQcInterrupted(),
      detectedIssues: this.detectedIssues(),
      isEditing: this.isEditing(),
      generalQcStatus: this.generalQcStatus(),
      aggregatedStatus: this.aggregatedStatus(),
    });

    return cssClass;
  });
}
